<template>
  <div class="go_img">
    <div class="main">
          <!-- 缩略图 -->
    <div class="is_imgs">
      <img :src="imgUrl" alt="缩略图" />
      <!-- <slot></slot> -->
    </div>
    <!-- 遮罩层 -->
    <!-- <div class="is_enlarge" @click="handleChange">
      <i class="iconfont icon-fangda1"></i>
    </div> -->
    <!-- 显示层 -->
    <div class="dialog" v-if="isShow">
      <div class="show_box">
        <i class="closed el-icon-circle-close" @click="handleChange"></i>
        <img :src="imgUrl" alt="原图显示" />
      </div>
    </div>
    </div>
    <div class="shows" >
      <i class="iconfont icon-fangda4" @click="handleChange"></i>
    </div>

  </div>
</template>

<script>
export default {
  name: 'enlargelmg',
  props: {
    imgUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: false
    };
  },
  methods: {
    handleChange() {
      this.isShow = !this.isShow;
    }
  }
};
</script>

<style scoped>
.go_img {
  width: 220px;
  height: 120px;
  position: relative;
}
.main{
  position: relative;
  float: left;
  width: 180px;
  height: 120px;
}
.shows{
  position: relative;
  float: right;
  width: 40px;
  height: 120px;
  line-height: 120px;
}
.shows i{
  margin-left: 20px;
}
.shows i:hover{
  font-size: 30px;
}
.is_imgs {
  width: 100%;
  height: 100%;
  position: absolute;
}
.is_imgs img {
  width: 100%;
  height: 100%;
}
.is_enlarge:hover {
  background: rgba(255, 245, 245, 0.548);
}
.is_enlarge {
  width: 100%;
  height: 100%;
  position: absolute;
  color: rgb(255, 255, 255);
  /* opacity: 0.5; */
  background: rgba(250, 247, 247, 0.144);
}
.is_enlarge i {
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 20px;
  transform: translate(-50%, -50%);
}
.dialog {
  position: fixed;
  /* display: block; */
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  z-index: 2222;
  width: 100%;
  height: 100%;
  /* background-color:#eee; */
  /* opacity: 0.3; 会影响子元素 */
  background: rgba(214, 214, 214, 0.3);
}
.show_box {
  max-width: 500px;
  max-height: 350px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.closed:hover{
  font-size: 30px;
}
.closed {
  width: 50px;
  height: 50%;
  position: absolute;
  top: -50px;
  right: -50px;
  width: 20px;
  height: 20px;
  font-size: 20px;
}
.show_box img {
  /* opacity: 1; */
  width: 100%;
  height: 100%;
}

</style>